module.exports = {
    type: 'object',
    additionalProperties: false,
    properties: {
        type: {
            type: 'string'
        },
        expirationMonth: {
            type: 'string'
        },
        expirationYear: {
            type: 'string'
        },
        verificationCode: {
            type: 'string'
        },
        encryptedCardNumber: {
            type: 'string'
        },
        trackOne: {
            type: 'string'
        },
        accertifyTransactionId: {
            type: ['string', 'null']
        }
    }
};
